// hello

console.log('✿ hello visitor, i wish you a lovely day ✿')
